import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import app from './app';
import auth from './auth';
import config from './config';

const rootReducer = combineReducers({
  app: persistReducer({
    key: 'ow',
    storage,
  }, app),
  config,
  auth,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/sub-projects/openweathermap/reducers/index.ts